var Backbone, SupportLiveChatFloatingTemplate, SupportLiveChatTemplate, SupportLiveChatView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportLiveChatTemplate = require('../../live_chat.html.mustache');

SupportLiveChatFloatingTemplate = require('../../live_chat_floating.html.mustache');

SupportLiveChatView = (function(superClass) {
  extend(SupportLiveChatView, superClass);

  function SupportLiveChatView() {
    return SupportLiveChatView.__super__.constructor.apply(this, arguments);
  }

  SupportLiveChatView.prototype.id = 'live-chat';

  SupportLiveChatView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.model = this.options.model;
    this.setTemplates();
    this.I18nScope = 'modules.support';
    this.liveChatImageInterval = setInterval(function() {
      var bcanchor, bcfloating;
      bcfloating = $(".bcFloat img, .bcStatic img");
      bcanchor = $(".bcFloat a, .bcStatic a");
      if (bcfloating.length) {
        bcfloating.attr("alt", I18n.translate('js.modules.support.chat_us'));
        return bcanchor.removeAttr("href").attr({
          "role": "button",
          "aria-label": I18n.translate('js.modules.support.chat_us'),
          "tabindex": "0"
        });
      }
    }, 3000);
    return this.liveChatTextInterval = setInterval(function() {
      var bcanchor;
      bcanchor = $(".bcText a");
      if (bcanchor.length) {
        return bcanchor.removeAttr("href").attr({
          "role": "button",
          "aria-label": I18n.translate('js.modules.support.chat_us'),
          "tabindex": "0"
        });
      }
    }, 3000);
  };

  SupportLiveChatView.prototype.render = function(params) {
    if (!params.startFromSameViewState) {
      this.$el.empty();
    }
    this.templates = window.getInArrayFormat(this.getTemplatesToRender());
    _.each(this.templates, (function(_this) {
      return function(template) {
        _this.setIntialQuestion(params);
        return _this.$el.append(toHtml(template, _this.model.toJSON(), _this.I18nScope));
      };
    })(this));
    return this;
  };

  SupportLiveChatView.prototype.setIntialQuestion = function(params) {
    return this.model.setIntialQuestion(params);
  };

  SupportLiveChatView.prototype.getTemplatesToRender = function() {
    if (this.model.has(this.model.get('mode'))) {
      return this.model.get(this.model.get('mode'));
    } else {
      return this.model.get('floating');
    }
  };

  SupportLiveChatView.prototype.setLiveChat = function(mode, liveChatType) {
    if (this.shouldRenderLiveChat()) {
      this.model.setLiveChatInfo(liveChatType);
      return this.model.set({
        mode: mode || 'static'
      });
    }
  };

  SupportLiveChatView.prototype.renderView = function(viewElem, params) {
    var liveChatConfig;
    if (params == null) {
      params = {};
    }
    if (this.shouldRenderLiveChat()) {
      liveChatConfig = this.model.get('liveChat');
      if (liveChatConfig && liveChatConfig.accountID) {
        this.render(params);
        return viewElem.append(this.$el);
      }
    }
  };

  SupportLiveChatView.prototype.shouldRenderLiveChat = function() {
    return this.model.isLiveChatEnabled() && this.checkForRefundEligibleConditionsToDisplayLiveChat();
  };

  SupportLiveChatView.prototype.checkForRefundEligibleConditionsToDisplayLiveChat = function() {
    var ref, ref1;
    if (evaluate(Groupon.Support.ContentModel.isRefundEligible)) {
      return ((ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.STATE) != null ? ref1.toUpperCase() : void 0 : void 0) === 'AVAILABLE';
    } else {
      return true;
    }
  };

  SupportLiveChatView.prototype.setTemplates = function() {
    this.model.set({
      'static': SupportLiveChatTemplate
    });
    this.model.set({
      'floating': SupportLiveChatFloatingTemplate
    });
    return this.model.set({
      'both': [this.model.get('static'), this.model.get('floating')]
    });
  };

  return SupportLiveChatView;

})(Backbone.View);

module.exports = SupportLiveChatView;

//# sourceMappingURL=data:application/json;base64,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
